import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';
import LoginCard from '../../3-molecules/login-card/login-card';
import MessageCard from '../../3-molecules/message-card/message-card';
import { modifierList as iconsModifiersList } from '../../1-foundation/icons/props-list';

import { modifierList } from './props-list';

const SetOfCards = ({
  render,
  isLoginCardVisible,
  isMessageCardVisible,
  loginCardText,
  messageCard,
  cards = [],
  iconsColor,
  iconsColorSecondary,
  modifiers,
  onLoginCardClose,
  onMessageCardClose,
  htmlId,
}) => {
  const setOfCardsModifiers = getClassNames('c-set-of-cards', modifiers);
  const cardsToShow = isLoginCardVisible || isMessageCardVisible ? cards.length - 1 : cards.length;
  const filteredCards = cards.slice(0, cardsToShow);
  const hasCards = filteredCards.length > 0;
  return (
    <div className={setOfCardsModifiers}>
      {isLoginCardVisible && hasCards && (
        <LoginCard htmlId={htmlId} loginCardText={loginCardText} onClose={onLoginCardClose} iconsColor={iconsColor} />
      )}
      {isMessageCardVisible && (
        <MessageCard
          iconsColor={iconsColorSecondary}
          onClose={onMessageCardClose}
          onClick={onMessageCardClose}
          text={messageCard.text}
          id={messageCard.id}
        />
      )}
      {filteredCards.map((item, index) => render(item, index))}
    </div>
  );
};

SetOfCards.propTypes = {
  render: PropTypes.func.isRequired,
  isLoginCardVisible: PropTypes.bool,
  isMessageCardVisible: PropTypes.bool,
  cards: PropTypes.array.isRequired,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
  onLoginCardClose: PropTypes.func,
  onMessageCardClose: PropTypes.func,
  htmlId: PropTypes.string,
  loginCardText: PropTypes.string,
  messageCard: PropTypes.shape({
    id: PropTypes.string,
    text: PropTypes.string,
  }),
  iconsColor: PropTypes.oneOf(iconsModifiersList),
  iconsColorSecondary: PropTypes.oneOf(iconsModifiersList),
};

export default SetOfCards;
